import React from 'react'
import { styled } from '@linaria/react';
import { useTheme, ITheme } from 'src/theme';
import Text from '@components/Text';
import ContactItem from '@components/_Revamp/ContactItem';
import Link from '@components/_Revamp/Link';
import { themeDefault } from 'src/theme-revamp';
import { css } from '@linaria/core';

interface StyledProps {
  margin?: string
}

const ContactUsContainer = styled.div<StyledProps>`
  display: block;
  width:100%;
  max-width: 327px;
  margin: 80px auto;
  @media screen and (min-width: 768px) {
    max-width: 588px;
    margin:${props=>props.margin ? props.margin : "auto"};
  }
  @media screen and (min-width: 1024px) {
    max-width: 792px;
  }
`
const ContactUsTitle = styled.div<StyledProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom:16px;
`
const ContactUsSubtitle = styled.div<StyledProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom:48px;
  margin-left: 60px;
  margin-right: 60px;
  @media screen and (max-width: 1024px) {
    margin-left: 0;
    margin-right: 0;
  }
`
const ContactUsItemsContainer = styled.div<StyledProps>`
  display: flex;
  flex-wrap:wrap;
  column-gap:40px;
  row-gap:24px;
`
const SubtitleCss = css`
  font-family: 'Open Sans';
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  font-weight: 600;
  color:#8A8988;
  @media screen and (max-width: 1024px) {
    font-weight: 400;
  }
`;

const TitleCss = css`
  font-family: 'Open Sans';
  font-size: 28px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: center;
  @media screen and (max-width: 1024px) {
    font-size: 20px;
  }
`;

export interface ContactUsProps {
  // children: React.ReactNode;
  id?: string | undefined;
  margin?: string
}

const contactItems = [
  { iconName: "contact-item-call", title: "Call", url: "tel:68279933", link: "+65 6827 9933", description1: "Mondays to Fridays: 8:45am – 5.30pm", description2: "(Closed on weekends and public holidays)" },
  { iconName: "contact-item-email", title: "Email", url: "mailto:cs_life@singlife.com", link: "cs_life@singlife.com", description1: "Send us an enquiry and we will respond within 24 hours.", description2: "" },
  { iconName: "contact-item-faq", title: "FAQ", url: "https://singlife.com/en/faq", link: "singlife.com/sg/faq", description1: "Need help? Check out our FAQ page", description2: "" },
  { iconName: "contact-item-ellipse", title: "Visit", url: "https://maps.app.goo.gl/ZTkae2oTdTUtLXqV6", link: "5 Straits View, #01-18/19, Marina One The Heart, Singapore 018935", description1: "Mondays to Fridays: 8:45am – 5.30pm", description2: "(Closed on weekends and public holidays)" },
]


function ContactUs({ id, margin }: ContactUsProps) {
  const theme: ITheme = useTheme();

  return (
    <ContactUsContainer margin={margin} id={id}>
      <ContactUsTitle>
        <Text className={TitleCss} color={"#434343"} fontWeight={600} fontSize={theme.fontSize.smallTitle}>Need help?</Text>
      </ContactUsTitle>
      <ContactUsSubtitle>
        <Text className={SubtitleCss} fontSize={theme.fontSize.text}>Any claim matters, click <Link url='https://singlife.com/en/make-a-claim' theme={themeDefault} text={"here"} /> to find out more on how to submit a claim.<br />For all other feedback and matters, please reach out to us below!</Text>
      </ContactUsSubtitle>
      <ContactUsItemsContainer>
        {
          contactItems.map((e, i: number) => {
            return <ContactItem key={i} iconName={e.iconName} title={e.title} link={e.link} description1={e.description1} description2={e.description2} url={e.url} />
          })
        }
      </ContactUsItemsContainer>
    </ContactUsContainer>
  )
}
export default ContactUs;